export default __webpack_public_path__ + "static/media/app_icon.29d48fb0.png";